app.views.easyPay = app.views.base.extend({
  childEvents: {
    'change [data-easypay-option]': 'onChangeEasyPayPaymentOption',
    'blur [data-easypay-payment-amount-input]': 'onChangeEasyPayPaymentAmountInput',
    'click [data-easypay-complete]': 'onEasyPayPaymentRequestComplete'
  },
  attr: {
    accountBalance: 'data-account-balance',
    paymentOption: 'data-easypay-option',
    paymentAmount: 'data-payment-amount',
    paymentTotal: 'data-payment-total',
    paymentMinimum: 'data-payment-minimumAmount',
    easyPayAmountInput: 'data-easypay-amount-input',
    EasyPayPaymentOther: 'data-easypay-payment-other',
    paymentDisplayAmount: 'data-display-payment-amount',
    dobDay: 'data-DOB-day',
    dobMonth: 'data-DOB-month',
    dobYear: 'data-DOB-year',
    spinner: 'data-form-spinner'
  },
  classes: {
    header: 'header',
    navigation: 'header-nav',
    actions: 'header-actions'
  },
  /**
    * Initialise Payment View Listener
    * @public
    * @constructor
    * @param {data} d : PaymentViewModel
    */

  init: function init() {
    this.hideElements();
  },
  /**
   * Initialise Card Expiry Dates
   * @private
   * @param {element} container : Payment Step Container
   */

  initDOBDates: function initDOBDates(container) {
    var day = $(container).find('[' + this.attr.dobDay + ']');
    var month = $(container).find('[' + this.attr.dobMonth + ']');
    var year = $(container).find('[' + this.attr.dobYear + ']');
    if ($(container).find(month).length > 0 && $(container).find(year).length > 0) {
      var date = new Date();
      var days = app.helpers.getDays('DD');
      var months = app.helpers.getMonths('MM');
      var currentYear = moment(date).format('YYYY');
      var minYear = parseInt(currentYear) - 120;
      var maxYear = parseInt(currentYear) - 17;
      var options = $.extend(app.options.select(), {
        minimumResultsForSearch: Infinity
      });
      $.each(days, function (i, d) {
        day.append('<option value="' + d + '">' + d + '</option>');
      });
      $.each(months, function (i, m) {
        month.append('<option value="' + m + '">' + m + '</option>');
      });
      for (var y = maxYear; y > minYear; y--) {
        year.append('<option value="' + y.toString() + '">' + y.toString() + '</option>');
      }
      day.select2(options);
      month.select2(options);
      year.select2(options);
    }
  },
  // ...

  initKeyPressEvents: function initKeyPressEvents() {
    var form = document.forms[0];
    if (form === null) return;
    $(form).keydown(function (event) {
      if (event.keyCode === 13 || event.key === 'Enter') {
        return false;
      }
    });
  },
  /**
   * Payment Step Change
   * Listens for a payment step change.
   * @private
   * @param {element} id : Payment Step Container
   */

  onChangePaymentStep: function onChangePaymentStep(id) {
    app.initElementListeners($(id));
    this.initDOBDates(id);
    this.initKeyPressEvents();
  },
  /**
   * On Begin Payment Step Change
   * Fires on the start of changing a payment step.
   * @private
   */

  onBeginChangePaymentStep: function onBeginChangePaymentStep() {
    $('[' + this.attr.spinner + ']').show();
  },
  onChangeEasyPayPaymentOption: function onChangeEasyPayPaymentOption(e) {
    var elm = $(e.currentTarget);
    var paymentOption = this.getPaymentOption(elm);
    var paymentValue = this.getPaymentValue(elm);
    var paymentTotal = $('[' + this.attr.paymentTotal + ']');
    if (paymentOption !== 'OtherAmount') {
      paymentTotal.html(paymentValue);
      this.clearInputValue();
      $('[data-easypay-amount]').hide();
      $('[data-easypay-total]').show();
    } else {
      $('[data-easypay-total]').hide();
      $('[data-easypay-amount]').show();
    }
  },
  /**
   * On Complete Payment Step Change
   * Fires on the completion of a paymetn step change.
   * @private
   */

  onCompleteChangePaymentStep: function onCompleteChangePaymentStep() {
    $('[' + this.attr.spinner + ']').hide();
  },
  /**
   * On Complete Payment Process
   * Fires when the user comppletes the easypay payment process
   * @public
   * @param {event} e : submit button event
   */

  onEasyPayPaymentRequestComplete: function onEasyPayPaymentRequestComplete(e) {
    var _this = this;
    var form = $(e.currentTarget).parents('form');
    e.preventDefault();
    $('[' + this.attr.spinner + ']').show();

    // If this is ever true then we have a big problem
    if (form === null || form === undefined) {
      console.error('No form found on page - unable to proceed to complete payment');
      return;
    }
    $.ajax({
      url: form[0].action,
      method: 'POST',
      data: form.serialize() + '&progression=complete',
      success: function success(data) {
        if (data === null) {
          console.error('Unable to complete payment process - the response is null');
          data = {
            hasErrors: true,
            errors: []
          };
          data.errors.push('There was an error processing your payment. Please try again later.');
        }
        if (data !== null && data.hasErrors) {
          // Write errors to UI
          var vs = $('[data-valmsg-summary]');
          $(vs).children('ul').empty();
          $.each(data.errors, function (i, item) {
            vs.children('ul').append($('<li></li>').text(item));
          });
          $(vs).addClass('validation-summary-errors');
          $('[' + _this.attr.spinner + ']').hide();
        }
        if (data !== null && data.redirectUrl !== null && data.redirectUrl !== undefined && data.redirectUrl !== '') {
          window.location = data.redirectUrl;
        }
      }
    });
  },
  clearInputValue: function clearInputValue() {
    $('[data-easypay-amount]').find('input').val('');
  },
  getPaymentOption: function getPaymentOption(element) {
    if (element !== undefined) {
      return element.attr(this.attr.paymentOption);
    } else {
      console.error('The payment option you selected is undefined.');
    }
  },
  getDisplayAmountField: function getDisplayAmountField() {
    return $('[' + this.attr.paymentDisplayAmount + ']');
  },
  getPaymentValue: function getPaymentValue(elm) {
    return elm.val();
  },
  getMinimumPaymentAmount: function getMinimumPaymentAmount() {
    return $('[' + this.attr.paymentMinimum + ']').val();
  },
  hideElements: function hideElements() {
    $('.' + this.classes.header).hide(); // TODO: Hide first
    $('.' + this.classes.navigation).hide();
    $('.' + this.classes.actions).hide();
    $('.' + this.classes.header).remove();
    $('.' + this.classes.navigation).remove();
    $('.' + this.classes.actions).remove();
  }
});